import {HttpRequest} from "../utils/httpRequest";

let IvUser = {
    /**
     * 获取数据列表
     * @param params
     * @returns {*}
     */
    getIvUserList(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/user/list',
            method: 'get',
            data: params
        });
    },
    /**
     * 获取个人数据
     * @param params
     * @returns {*}
     */
    getIvPersonal(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/user/personal',
            method: 'get',
            data: params
        });
    },
    /**
     * 获取个人所有数据
     * @param params
     * @returns {*}
     */
    getIvUsers(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/user/all/' + params,
            method: 'get'
        });
    },
    /**
     * 根据id查看信息
     * @param id
     * @returns {*}
     */
    getIvUserInfo(id) {
        return HttpRequest.getRequest({
            url: '/edu/invite/user/info/' + id,
            method: 'get'
        });
    },
    /**
     * 添加或编辑数据
     * @param type
     * @param datas
     * @returns {*}
     */
    addOrUpdateIvUser(type, datas) {
        return HttpRequest.getRequest({
            url: '/edu/invite/user/' + type,
            method: 'post',
            data: datas
        });
    },
    /**
     * 删除数据
     * @param params
     * @returns {*}
     */
    deleteIvUser(params) {
        return HttpRequest.getRequest({
            url: '/edu/invite/user/delete',
            method: 'get',
            data: params
        });
    }
};
export {IvUser}
